<div class="add-section-btn-container"
     (click)="onAddSection.emit()">
  <i class="db-icon db-icon-ds-sharp-plus"></i>
  <span>{{ 'text_addSection' | dbText }}</span>
</div>
